module.exports = __webpack_public_path__ + "static/media/drone3.87a8270c.png";